import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryNav from './components/CategoryNav';
import MovieSection from './components/MovieSection';
import HotRanking from './components/HotRanking';
import { movies } from '@/mocks/movies';

export default function Home() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const featuredMovies = movies.filter((m) => m.featured);
  const latestMovies = movies.filter((m) => m.category === 'movie').slice(0, 10);
  const latestTV = movies.filter((m) => m.category === 'tv').slice(0, 10);
  const latestAnime = movies.filter((m) => m.category === 'anime').slice(0, 5);
  const hotRanking = movies.filter((m) => m.hotRank && m.hotRank <= 10).sort((a, b) => (a.hotRank || 99) - (b.hotRank || 99));

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '悟空影视',
    url: 'https://www.wukongyingshi.com',
    description: '悟空影视免费观看平台，提供高清电影、电视剧、动漫、综艺在线观看服务，无需注册即点即播。',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://www.wukongyingshi.com/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <Hero />
          <CategoryNav />
          <MovieSection
            title="精选推荐"
            subtitle="为您精心挑选的高分佳作"
            movies={featuredMovies.slice(0, 5)}
            viewAllLink="/category/movie"
          />
          <MovieSection
            title="热门电影"
            subtitle="最新上映的热门大片"
            movies={latestMovies.slice(0, 5)}
            viewAllLink="/category/movie"
          />
          <MovieSection
            title="热播电视剧"
            subtitle="追剧达人不可错过"
            movies={latestTV.slice(0, 5)}
            viewAllLink="/category/tv"
          />
          <HotRanking movies={hotRanking} />
          <MovieSection
            title="热门动漫"
            subtitle="二次元的世界等你来探索"
            movies={latestAnime}
            viewAllLink="/category/anime"
          />
          <MovieSection
            title="最新更新"
            subtitle="最近更新的影视资源"
            movies={movies.filter((m) => !m.featured).slice(0, 5)}
            viewAllLink="/category/variety"
          />
        </main>
        <Footer />
      </div>
    </>
  );
}